<template>
  <div class="atlas-opt-in-landing">
    <AtlasOptInHero :customerId="customerId" />
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import AtlasOptInHero from "@components/AtlasOptInHero.vue";
import { MetricSender } from "@/helpers/MetricSender";

const route = useRoute();

const customerId = ref(route.params.customerId as string);

onMounted(async () => {
  MetricSender.sendMetric("Cust-Calendar-Landing-PageView", { customerId: customerId.value });
});
</script>

<style scoped lang="scss">
.atlas-opt-in-landing {
  min-height: 100vh;
  background: white;
}
</style>
